import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    search: "",
    searchTag: 'all',
    searchHistory: [] 
  },
  mutations: {
    getSearchWord(state, key) {
      state.search = key
    },
    getSearchTag(state, key) {
      state.searchTag = key
    },
    getSearchHistory(state, key) {
      state.searchHistory.unshift(key)
    },
    claerHistoty(state) {
      state.searchHistory = []
    }

  },
  actions: {
  },
  modules: {
  }
})
